import { render, staticRenderFns } from "./LiveDateTime.vue?vue&type=template&id=1c47479f&"
import script from "./LiveDateTime.vue?vue&type=script&lang=js&"
export * from "./LiveDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports